import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as actionType from './actionType';
import { initialState } from './reducer';

// get the data entered by user
export const dispatchRequestData = (data) => ({
  type: actionType.SEARCH_REQUEST_TAB,
  requestScreen: data,
});

export const setCreateTemplateExtraState = (data) => ({
  type: actionType.GET_CREATE_TEMPLATE_EXTRA_STATE,
  payload: data,
});

export const dispatchDetailData = (data) => {
  return {
    type: actionType.GET_DETAIL_DATA,
    payload: data,
  };
};

export const dispatchTemplateTypeList = (data) => ({
  type: actionType.GET_TEMPLATE_TYPE_LIST_CREATE,
  templateType: data.TEMPLATE_TYPE_CD,
  payload: data.PLAN_TYPE_CD,
});

export const getTemplateTypeList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.NDC_REFERENCE_DATA, value)
    .then((response) => {
      if (response.data) {
        return dispatch(dispatchTemplateTypeList(response.data));
      }
    })
    .catch((response) => {
      dispatch(dispatchTemplateTypeList([]));
    });
};

export const dispatchTemplateNameList = (data) => ({
  type: actionType.GET_TEMPLATE_NAME_LIST,
  templateName: data,
});

export const getTemplateNameList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_TEMPLATE_BY_TYPE, value)
    .then((response) => {
      if (response.data) {
        let data = [];
        if (response.data && response.data.message === 'SUCESS') {
          data = response.data.data || response.data.letterTemplate;
        }
        return dispatch(dispatchTemplateNameList(data));
      }
    })
    .catch((response) => {
      dispatch(dispatchTemplateNameList([]));
    });
};

// get rebate programe funnction
export const getRebateProgrameList = (value) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      let data = [];
      if (response.data && response.data.message === 'SUCESS') {
        data = response.data.data;
      }
      return data;
    })
    .catch((response) => {
      return [];
    });
};

export const dispatchManufacturerData = (data) => ({
  type: actionType.GET_MANUFACTURER_DATA,
  manufacturer: data,
});

export const getManufacturerData = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_MFG_LIST, value)
    .then((response) => {
      let data = [];
      if (response.data && response.data.message === 'SUCESS') {
        data = response.data.data || response.data.createLetterMfgVO;
      }
      return dispatch(dispatchManufacturerData(data));
    })
    .catch((response) => {
      dispatch(dispatchManufacturerData([]));
    });
};

// dispatch quarter value function
export const dispatchQuarterValue = (data) => ({
  type: actionType.GET_QUARTER_VALUE,
  payload: data,
});

//  get quarter value data
export const getQuarterValue = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_QUARTER_DATA)
    .then((response) => {
      return dispatch(dispatchQuarterValue(response.data));
    })
    .catch((response) => {
      dispatch(dispatchQuarterValue([]));
    });
};

export const dispatchFetchCreateLetterDetail = (data) => ({
  type: actionType.FETCH_CREATE_LETTER_DETAIL_CREATE,
  payload: data,
});

export const updateCreateLetterDetail = (data) => (dispatch) => {
  dispatch(dispatchFetchCreateLetterDetail(data));
};

export const fetchCreateLetterDetail = (value) => (dispatch) => {
  const finalData = {
    searchData: value.searchData,
    letterDetail: [],
    headerDetail: value.headerDetail,
  };
  return axios
    .post(serviceEndPoint.CREATE_LETTER_DETAIL_PREVIEW, value.request)
    .then((response) => {
      if (response.data && response.data.message === 'SUCESS') {
        finalData.letterDetail =
          response.data.data || response.data.printPreviewVO;
      }
      return dispatch(dispatchFetchCreateLetterDetail(finalData));
    })
    .catch((response) => {
      dispatch(dispatchFetchCreateLetterDetail(finalData));
    });
};

export const dispatchFetchCreateLetterDetailData = (data) => ({
  type: actionType.FETCH_CREATE_LETTER_DETAIL_DATA_CREATE,
  payload: data,
});

export const updateCreateLetterDetailData = (data) => (dispatch) => {
  dispatch(dispatchFetchCreateLetterDetailData(data));
};

export const fetchCreateLetterDetailData = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.CREATE_LETTER_DETAIL_PREVIEW, value.request)
    .then((response) => {
      let data = [];
      if (response.data && response.data.message === 'SUCESS') {
        data = response.data.data || response.data.printPreviewVO;
      }
      data = {
        ...response.data,
        result: {
          searchData: value.searchData,
          letterDetail: data,
          headerDetail: value.headerDetail,
        },
      };
      return dispatch(dispatchFetchCreateLetterDetailData(data));
    })
    .catch((response) => {
      dispatch(
        dispatchFetchCreateLetterDetailData({
          message: 'FAIL',
          status: '000',
          result: null,
        })
      );
    });
};

// getLetterIdFromApi
export const dispatchSaveCreateLetter = (data) => ({
  type: actionType.SAVE_CREATE_LETTER_DATA_CREATE,
  payload: data,
});

export const updateCreateLetterSaveApi = (data) => (dispatch) => {
  dispatch(dispatchSaveCreateLetter(data));
};

export const saveCreateTemplate = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SAVE_CREATE_LETTER, value)
    .then((response) => {
      return dispatch(dispatchSaveCreateLetter(response.data));
    })
    .catch((response) => {
      dispatch(dispatchSaveCreateLetter({ message: 'FAIL', status: '000' }));
    });
};

// update free from text value
export const updateFreeFromTextCreateTemplate = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_FREE_FROM_TEXT, value)
    .then((response) => {
      return dispatch(dispatchSaveCreateLetter(response.data));
    })
    .catch((response) => {
      dispatch(dispatchSaveCreateLetter({ message: 'FAIL', status: '000' }));
    });
};

// after send mail update send date
export const afterMailSendUpdateSendDate = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_SENT_DATE, value)
    .then((response) => {
      return dispatch(dispatchSaveCreateLetter(response.data));
    })
    .catch((response) => {
      dispatch(dispatchSaveCreateLetter({ message: 'FAIL', status: '000' }));
    });
};

// get to mail id
export const dispatchGetToMailID = (data) => ({
  type: actionType.GET_TO_MAIL_ID_CREATE,
  payload: data,
});

// update to mail id value
export const updateToMailIDCreateTemplate = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_TO_MAIL_ID, value)
    .then((response) => {
      let newData = '';
      if (
        response.data &&
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        newData = response.data.data || response.data.updatedMailId;
      }
      const data = { isUpdate: true, toMailId: newData };
      return dispatch(dispatchGetToMailID(data));
    })
    .catch((response) => {
      dispatch(dispatchGetToMailID([]));
    });
};

// get from mail id
export const dispatchGetFromMailID = (data) => ({
  type: actionType.GET_FROM_MAIL_ID_CREATE,
  payload: data,
});

export const getFromMailIDCreateTemplate = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_FROM_MAIL_ID, value)
    .then((response) => {
      let newData = '';
      if (
        response.data &&
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        newData = response.data.data || response.data.fromMailId;
      }
      const data = { isUpdate: false, fromMailId: newData };
      return dispatch(dispatchGetFromMailID(data));
    })
    .catch((response) => {
      dispatch(dispatchGetFromMailID([]));
    });
};

// update from mail id value
export const updateFromMailIDCreateTemplate = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_FROM_MAIL_ID, value)
    .then((response) => {
      let newData = '';
      if (
        response.data &&
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        newData = response.data.data || response.data.updatedMailId;
      }
      const data = { isUpdate: true, fromMailId: newData };
      return dispatch(dispatchGetFromMailID(data));
    })
    .catch((response) => {
      dispatch(dispatchGetFromMailID([]));
    });
};

// all send email with letest content
export const dispatchSendMailForLetter = (data) => ({
  type: actionType.SEND_LETTER_BY_EMAIL_CREATE,
  sendMail: data,
});

export const sendMailWithCreateTemplate = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SEND_LETTER_BY_EMAIL, value)
    .then((response) => {
      return dispatch(dispatchSendMailForLetter(response.data));
    })
    .catch(() => {
      dispatch(
        dispatchSendMailForLetter({
          message: 'FAIL',
          status: '000',
          actionFlag: 'Email Send Fail.',
        })
      );
    });
};

export const dispatchErrorMsg = (data) => ({
  type: actionType.GET_ERROR_MSG_CREATE_LETTER,
  payload: data,
});

export const dispatchGetInvDetailByInvBeforeRedirect = (data) => ({
  type: actionType.GET_INVOICE_DETAILS_BY_INVOICE_NUM_BEFOR_CREATE,
  getInvDetail: data,
});

export const dispatchGetInvoiceDetailsByInvoiceNum = (data) => ({
  type: actionType.GET_INVOICE_DETAILS_BY_INVOICE_NUM_CREATE,
  invoiceDetail: data,
});

export const updateInvoiceDetailsByInvoiceNum = (data) => (dispatch) => {
  dispatch(dispatchGetInvoiceDetailsByInvoiceNum(data));
};

export const getInvoiceDetailsByInvoiceNum = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_INVOICE_DETAILS_BY_INVOICE_NUM, {
      invoiceNum: value.invoiceNum,
    })
    .then((response) => {
      let newData = [];
      if (
        response.data &&
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        newData = response.data.data;
      }
      if (value.isReturn) {
        return dispatch(dispatchGetInvDetailByInvBeforeRedirect(response.data));
      }
      return dispatch(dispatchGetInvoiceDetailsByInvoiceNum(newData));
    })
    .catch((response) => {
      if (value.isReturn) {
        return dispatch(
          dispatchGetInvDetailByInvBeforeRedirect({
            status: '000',
            message: 'FAIL',
            data: null,
          })
        );
      }
      dispatch(dispatchGetInvoiceDetailsByInvoiceNum([]));
    });
};

export const dispatchPrintPreview = (data) => ({
  type: actionType.GET_PRINT_PREVIEW_CREATE,
  pdfPreview: data,
});

export const getPrintPreview = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PDF_PRINT_PREVIEW, value, {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => {
      dispatch(getPrintPreviewWithoutBuffer(value));
      const newData1 = response.data;
      return dispatch(dispatchPrintPreview(newData1));
    })
    .catch((response) => {
      dispatch(dispatchPrintPreview([]));
    });
};

export const dispatchPrintPreviewContent = (data) => ({
  type: actionType.GET_PRINT_PREVIEW_CONTENT,
  pdfPreviewContent: data,
});

export const getPrintPreviewWithoutBuffer = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.PDF_WITHOUT_BUFFER, value, {
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => {
      const newData1 = response.data;
      return dispatch(dispatchPrintPreviewContent(newData1));
    })
    .catch((response) => {
      dispatch(dispatchPrintPreview([]));
    });
};

export const dispatchPrintDraftPDFPreview = (data) => ({
  type: actionType.GET_PREVIEW_DRAFT_PDF_CREATE,
  pdfDraftPreview: data,
});

export const getPrintDraftPDFPreview = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.PREVIEW_DRAFT_PDF, value, {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => {
      const newData = response.data;
      return dispatch(dispatchPrintDraftPDFPreview(newData));
    })
    .catch((response) => {
      dispatch(dispatchPrintDraftPDFPreview(''));
    });
};

export const clearCreateLetterPageDispatch = (val) => {
  return { type: actionType.CREATE_LETTER_CLEAR_REDUX_DATA, payload: val };
};

export const clearCreateLetterPage = () => (dispatch, getState) => {
  const reduxObj = getState()?.sharedState?.CreateLetterReducer;
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  let newObj1 = {};
  if (!_.isEmpty(updateTabs)) {
    const newObj = _.cloneDeep(reduxObj);
    if (
      updateTabs.filter(
        (x) => x.navTo === '/createLetter' || x.navTo === '/createLetterDetail'
      ).length !== 0
    ) {
      newObj1 = newObj;
      if (
        updateTabs.filter((x) => x.navTo === '/createLetterDetail').length === 0
      ) {
        newObj1 = {
          ...newObj1,
          detailScrenData: {
            searchData: {},
            letterDetail: {},
            headerDetail: {},
          },
          getInvDetail: [],
          invoiceDetail: [],
          createLetterDetail: [],
          saveCreateLetterData: [],
          getLetterId: {},
          getupdateSendDate: {},
          toMailId: {},
          fromMailId: {},
          sendMail: {},
          pdfPreviewContent: [],
          pdfPreview: '',
          pdfDraftPreview: '',
        };
      }
    } else {
      newObj1 = { ...initialState };
    }
  } else {
    newObj1 = { ...initialState };
  }

  dispatch(clearCreateLetterPageDispatch(newObj1));
};
